/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_HealthInputs */

const en_us2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health`)
};

const pt_br2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const es_419_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salud`)
};

const pt_pt2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saúde`)
};

const fr_fr2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé`)
};

const de_de2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheit`)
};

const it_it2_profile_section_health = /** @type {(inputs: Profile_Section_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salute`)
};

/**
* | output |
* | --- |
* | "Health" |
*
* @param {Profile_Section_HealthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_health = /** @type {((inputs?: Profile_Section_HealthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_HealthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_health(inputs)
	if (locale === "es-419") return es_419_profile_section_health(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_health(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_health(inputs)
	if (locale === "de-DE") return de_de2_profile_section_health(inputs)
	if (locale === "it-IT") return it_it2_profile_section_health(inputs)
	return en_us2_profile_section_health(inputs)
});
export { profile_section_health as "profile.section_health" }